import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '../svg-icon';

export const ChevronsIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon stroke="currentColor" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 8.5L10 13.5L15 8.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);
